import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';

import {HttpService} from "./http-service";

import {TAction} from "../app/enum";
import 'rxjs/add/operator/map';


@Injectable()
export class SpotdayService {

    constructor(public http: HttpService) {

    }

    spotday(action: TAction, spotdayID: number = 0, hotspotID: number = 0, profileID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Spotday?Action=' + TAction[action] + '&SpotdayID=' + spotdayID + '&HotspotID=' + hotspotID + '&ProfileID=' + profileID;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url);

    }


}



// WEBPACK FOOTER //
// ./src/providers/spotday-service.ts